import { useState } from 'react';
import { updateJobCost } from '../api/jobCosts';
import type { CreateJobCostRequest, JobCost } from '../types/jobCost';

/**
 * Hook for updating an existing job cost
 */
export function useUpdateJobCost() {
  const [isUpdating, setIsUpdating] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const update = async (
    jobId: number,
    costId: number,
    data: CreateJobCostRequest
  ): Promise<JobCost | null> => {
    setIsUpdating(true);
    setError(null);
    try {
      const cost = await updateJobCost(jobId, costId, data);
      return cost;
    } catch (err) {
      const error = err as { response?: { data?: { message?: string } } };
      setError(error.response?.data?.message || 'Failed to update job cost');
      return null;
    } finally {
      setIsUpdating(false);
    }
  };

  return {
    update,
    isUpdating,
    error,
  };
}
